import { render, staticRenderFns } from "./blogPortal.vue?vue&type=template&id=80607cde&scoped=true"
import script from "./blogPortal.vue?vue&type=script&lang=js"
export * from "./blogPortal.vue?vue&type=script&lang=js"
import style0 from "./blogPortal.vue?vue&type=style&index=0&id=80607cde&prod&lang=css"
import style1 from "./blogPortal.vue?vue&type=style&index=1&id=80607cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80607cde",
  null
  
)

export default component.exports